module.exports = __webpack_public_path__ + "static/media/cash-deposit.cbbc58b3.svg";